import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const SalesRepDepartmentSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Sales Rep Department Data from Google Sheets"
      syncType={SyncType.SalesRepDepartment}
      pageId={PageId.SalesRepDepartment}
      defaultSheetUrl={defaultSheets.SalesRepDepartment.defaultSheetUrl}
      defaultRange={defaultSheets.SalesRepDepartment.defaultRange}
    />
  );
};

export default SalesRepDepartmentSyncPage;
